export async function requestSubscription(): Promise<void> {
  // Noop on the web
}
